// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"316":"component---src-templates-1-top-index-jsx","360":"component---src-pages-404-index-jsx","680":"component---src-pages-contact-thanks-index-jsx"}[chunkId] + "-" + {"316":"c43c66b45b62bf15b637","360":"a02482a94f3990b2987e","680":"402b330ad39dde40e397"}[chunkId] + ".js";
};